import { get, post } from '@/api/request';
import { apiPrefix } from '@/api/url';

// 百应创建通话
// export const agentCallOut = (params) => post(apiPrefix.baseApi + "/callRecord/save", params)
export const agentCallOut = (params={}) => {
  const {jobOrderId, ...rest} = params;
  const userInfo = localStorage.getItem('userInfo');
  if (userInfo){
    const userId = JSON.parse(userInfo).id;
    rest.operatorId = userId;
  }
  if (typeof jobOrderId === 'number' || jobOrderId > 0) {
    rest.jobOrderIdInt = jobOrderId;
  } else {
    rest.jobOrderId = jobOrderId;
  }
  return post(apiPrefix.baseApi + "/callRecord/save", rest);
}
// 挂断上报
export const callRecordBindQywx = (params) => get(apiPrefix.baseApi + "/callRecord/bindQywx", params)

export const agentGetCustomerIdBaiYing = (params) => get(apiPrefix.baseApi + "/cti/agentGetCustomerIdBaiYing", params)

export const getListCtiCompanyType = (params) => get(apiPrefix.baseApi + "/ctiCompany/listNoPage", params)

export const queryJobOrderIdByAgentId = (params) => get(apiPrefix.baseApi + "/jobOrder/autoCall", params)


// 更新坐席工作状态rgyb
export const updateAgentState = (params) => post(apiPrefix.attendApi + "/attend/updateState", params)

// 回拨挂断评分
export const ratingHangupe = (params) => get(apiPrefix.attendApi + "/rating/hangup", params)